var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { LABEL } from '../componentTypes';
import EventContext from '../context/event-context';
import StateContext from '../context/state-context';
import { StyledDivContainer, TextComponent } from './Grid';
export function LabelContainer(props) {
    var _a, _b, _c;
    var children = props.children, id = props.id;
    if ((children === null || children === void 0 ? void 0 : children.length) != 1 && children[0].type != LABEL) {
        return React.createElement("div", __assign({}, props, { "data-debug": "config_error" }));
    }
    var labelComponent = children[0];
    var _onLabelClick = useContext(EventContext)._onLabelClick;
    var onLabelClick = function (evt) {
        _onLabelClick(id);
    };
    var state = useContext(StateContext);
    var label = (_a = state[id + "_label"]) !== null && _a !== void 0 ? _a : labelComponent.label;
    var backgroundColor = (_b = state[id + "_backgroundColor"]) !== null && _b !== void 0 ? _b : props.backgroundColor;
    var fontColor = (_c = state[id + "_fontColor"]) !== null && _c !== void 0 ? _c : props.color;
    return (React.createElement(StyledDivContainer, __assign({ onClick: onLabelClick }, props, { backgroundColor: backgroundColor, color: fontColor }),
        React.createElement(TextComponent, { label: label })));
}
//# sourceMappingURL=LabelContainer.js.map